import * as THREE from 'three';
import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';

const ChromaticAberrationShader = {
  uniforms: {
    tDiffuse: { value: null as THREE.Texture | null },
    uStrength: { value: 0.0 },
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform float uStrength;
    varying vec2 vUv;
    void main() {
      vec2 offset = (vUv - 0.5) * uStrength * 0.012;
      float r = texture2D(tDiffuse, vUv - offset).r;
      float g = texture2D(tDiffuse, vUv).g;
      float b = texture2D(tDiffuse, vUv + offset).b;
      gl_FragColor = vec4(r, g, b, 1.0);
    }
  `,
};

export class FpsChromaticAberration {
  public readonly pass: ShaderPass;
  private strength = 0;
  private timer = 0;
  private duration = 0;

  constructor() {
    this.pass = new ShaderPass(ChromaticAberrationShader);
    this.pass.uniforms['uStrength'].value = 0;
  }

  trigger(strength: number, duration: number): void {
    this.strength = strength;
    this.timer = duration;
    this.duration = duration;
  }

  update(dt: number): void {
    if (this.timer > 0) {
      this.timer -= dt;
      const t = Math.max(0, this.timer / this.duration);
      this.pass.uniforms['uStrength'].value = this.strength * t;
    } else {
      this.pass.uniforms['uStrength'].value = 0;
    }
  }

  setStrength(v: number): void {
    this.pass.uniforms['uStrength'].value = v;
  }
}
